module.exports = __webpack_public_path__ + "static/media/caoBk.fab46101.jpeg";